import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';

import {
	addToCart,
	fetchCartProducts,
	reduceFromCart,
} from 'store/slices/cartSlice';
import { setCartPopupOpen } from 'store/slices/layoutSlice';
import useCustomer from 'hooks/useCustomer';
import { getStock, getMaxAvailableInCartUnit } from 'helpers/product';
import Icon from 'components/Icon';

const CartQtyButtonGroup = ({ item, size = 'middle', block = false }) => {
	const [stock, setStock] = useState(() => getStock(item));
	const dispatch = useDispatch();
	const { customer } = useCustomer();
	const { data } = useSelector(state => state.cart.cartProducts);
	const inCart = data.products?.find(p => +p.product_id === +item.product_id);

	const handleAddToCart = async (product_id, quantity = 1, e) => {
		e.stopPropagation();
		await addToCart(
			product_id,
			quantity,
			customer.token ? undefined : item
		);
		dispatch(fetchCartProducts({ refetchAfterMutation: true }));
		dispatch(setCartPopupOpen(true));
	};

	const handleReduceToCart = async e => {
		e.stopPropagation();
		await reduceFromCart(item.product_id, 1);
		dispatch(fetchCartProducts({ refetchAfterMutation: true }));
		dispatch(setCartPopupOpen(true));
	};

	// Определяем размеры в зависимости от size
	const buttonHeight =
		size === 'small' ? '36px' : size === 'large' ? '48px' : '42px';
	const iconSize = size === 'small' ? 16 : size === 'large' ? 20 : 18;
	const fontSize =
		size === 'small' ? '14px' : size === 'large' ? '16px' : '14px';

	if (inCart) {
		const maxAvailable = getMaxAvailableInCartUnit(inCart || item);
		const qty = Number(inCart.quantity) || 0;
		const step = Number(item.minimum) || 1;
		const plusDisabled = qty + step > maxAvailable;
		return (
			<div
				className='add-to-cart-quantity-group'
				style={{
					width: '100%',
					display: 'flex',
					marginBottom: size === 'small' ? '0' : '16px',
				}}
			>
				<button
					onClick={handleReduceToCart}
					className='popular-product-button'
					style={{
						height: buttonHeight,
						width: buttonHeight,
						padding: 0,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						borderTopLeftRadius: '8px',
						borderBottomLeftRadius: '8px',
						borderTopRightRadius: 0,
						borderBottomRightRadius: 0,
						marginBottom: 0,
						flexShrink: 0,
						border: 'none',
					}}
				>
					<MinusOutlined style={{ fontSize: iconSize, color: '#fff' }} />
				</button>
				<Input
					value={`${inCart.quantity} ${item.main_unit || 'шт'}`}
					readOnly
					style={{
						height: buttonHeight,
						textAlign: 'center',
						flex: '1',
						minWidth: size === 'small' ? 56 : 72,
						borderRadius: 0,
						borderLeft: 'none',
						borderRight: 'none',
						fontFamily: "'TT Firs Neue', sans-serif",
						fontSize: fontSize,
						fontWeight: 600,
					}}
				/>
				<button
					onClick={e => handleAddToCart(item.product_id, item.minimum, e)}
					disabled={plusDisabled}
					className='popular-product-button'
					style={{
						height: buttonHeight,
						width: buttonHeight,
						padding: 0,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						borderTopLeftRadius: 0,
						borderBottomLeftRadius: 0,
						borderTopRightRadius: '8px',
						borderBottomRightRadius: '8px',
						marginBottom: 0,
						flexShrink: 0,
						border: 'none',
					}}
				>
					<PlusOutlined style={{ fontSize: iconSize, color: '#fff' }} />
				</button>
			</div>
		);
	}

	return (
		<button
			className='popular-product-button'
			onClick={e => handleAddToCart(item.product_id, item.minimum, e)}
			disabled={stock.stock < item.minimum}
			style={{
				width: '100%',
				height: buttonHeight,
				marginBottom: size === 'small' ? '0' : '16px',
				fontSize: fontSize,
			}}
		>
			<Icon
				name='icon-shopping-cart'
				className='popular-product-button-icon'
				width={size === 'small' ? 18 : 24}
				height={size === 'small' ? 18 : 24}
			/>
			<span>В корзину</span>
		</button>
	);
};

export default CartQtyButtonGroup;
